export default __webpack_public_path__ + "3fc3afb7df769bd0a19959a2f0049fb4.jpg";